import { Typography, Descriptions, Button, Space, Alert } from 'antd';
import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { withDevModalFilePath } from '../common';

const { Modal } = withDevModalFilePath('client/src/components/dev/DevEmailPreviewModal.tsx');

const { Text, Link } = Typography;

interface DevEmailData {
  to: string;
  name: string;
  subject: string;
  html: string;
  setupUrl: string;
  token: string;
  expiresAt: string;
  sentAt: string;
}

interface DevEmailPreviewModalProps {
  open: boolean;
  onClose: () => void;
  emailData: DevEmailData | null;
}

/**
 * 開発環境専用のメールプレビューモーダル
 * NODE_ENV=development のときのみ使用
 */
export function DevEmailPreviewModal({
  open,
  onClose,
  emailData,
}: DevEmailPreviewModalProps) {
  if (!emailData) {
    return null;
  }

  const handleCopySetupUrl = () => {
    navigator.clipboard.writeText(emailData.setupUrl);
  };

  const handleOpenSetupUrl = () => {
    window.open(emailData.setupUrl, '_blank');
  };

  return (
    <Modal
      title="[開発環境] 送信メールプレビュー"
      open={open}
      onCancel={onClose}
      width={800}
      footer={[
        <Button key="close" onClick={onClose}>
          閉じる
        </Button>,
      ]}
    >
      <Alert
        message="開発環境専用表示"
        description="この表示は開発環境（NODE_ENV=development）でのみ表示されます。本番環境では表示されません。"
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="宛先">{emailData.to}</Descriptions.Item>
        <Descriptions.Item label="宛名">{emailData.name}</Descriptions.Item>
        <Descriptions.Item label="件名">{emailData.subject}</Descriptions.Item>
        <Descriptions.Item label="有効期限">
          {new Date(emailData.expiresAt).toLocaleString('ja-JP')}
        </Descriptions.Item>
        <Descriptions.Item label="送信日時">
          {new Date(emailData.sentAt).toLocaleString('ja-JP')}
        </Descriptions.Item>
      </Descriptions>

      <div style={{ marginTop: 16, marginBottom: 16 }}>
        <Text strong>セットアップURL:</Text>
        <div
          style={{
            background: '#f5f5f5',
            padding: '8px 12px',
            borderRadius: 4,
            marginTop: 8,
            wordBreak: 'break-all',
          }}
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            <Link href={emailData.setupUrl} target="_blank">
              {emailData.setupUrl}
            </Link>
            <Space>
              <Button
                size="small"
                icon={<CopyOutlined />}
                onClick={handleCopySetupUrl}
              >
                URLをコピー
              </Button>
              <Button
                size="small"
                type="primary"
                icon={<LinkOutlined />}
                onClick={handleOpenSetupUrl}
              >
                URLを開く
              </Button>
            </Space>
          </Space>
        </div>
      </div>

      <div style={{ marginTop: 16 }}>
        <Text strong>メール本文プレビュー:</Text>
        <div
          style={{
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            padding: 16,
            marginTop: 8,
            background: '#fff',
          }}
          dangerouslySetInnerHTML={{ __html: emailData.html }}
        />
      </div>
    </Modal>
  );
}
